export default __webpack_public_path__ + "static/media/arrow-down.e6669f59.svg";